export const loadCopilotBar = () => import('./index');
